import React from "react";
import { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { ApplicationState } from "../store";
import * as APIStore from "../store/APIStore";
import { Slide, Typography } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { TableFooter, TableCell, TableRow, Paper } from "@material-ui/core";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import RequestAccessToken from "../util/authService";
import DoneAllIcon from '@material-ui/icons/DoneAll';
import { red } from '@material-ui/core/colors';
import Hidden from '@material-ui/core/Hidden';
import { Grid } from '@material-ui/core';
import './style.css';
import './PatientsTable.css';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import SelectableText from './common/SelectableText'

type PatientsByRefMDProps = {
    Patients: APIStore.PatientState,
    userPracticeCoordinatorProfile: APIStore.PracticeCoordinatorState,
    APIToken: APIStore.TokenType
} &
    typeof APIStore.actionCreators;

const fetchPatientsForPractice = (
    accessToken: string,
    practiceId: number,
    practiceCoordId: number,
    daysBack: number,
    actionMethod: Function
) => {
    actionMethod(practiceId, practiceCoordId, daysBack, accessToken);
};

const SPACED_DATE_FORMAT = "MM-DD-YYYY";
const ADMIT_STAMP_COL_NUM = 10;

const formatDate = (date: string, dateOnly: boolean) => {
    if (!date) {
        return 'N/A';
    }
    if (dateOnly) {
        return moment(date).format("MM-DD-YYYY");
    }
    return moment(date).format("hh:mm:ss A MM-DD-YYYY");
};

const formatPCPUserName = (userName: String) => {
    if (!userName) {
        return ''
    }

    userName = userName.trim()

    return userName;
}

const formatAssignedMD = (contact: APIStore.HNIProviderContact) => {
    if (!contact) {
        return '';
    }
    if (contact.type.startsWith('Program')) {
        return '';
    }

    return contact.displayName;
}

const useStyles = makeStyles({
    root: {
        width: 300,
    },
});

const getMuiTheme = () =>
    createTheme({
        overrides: {
            MUIDataTableBodyCell: {
                root: {
                    backgroundColor: "#FFFFFF",
                    padding: "1em",
                },
            },

            MuiInput: {
                underline: {
                    color: "#00AAD1",
                },
                colorSecondary: {
                    color: "#00AAD1",
                },
            },
            MUIDataTablePagination: {
                root: {
                    backgroundColor: "rgba(53, 162, 235, 0.1)",
                },
            },
        },
    });


const PracticeCoordinatorPatientsTable = (props: PatientsByRefMDProps) => {
    let [tokenState, setTokenState] = useState<APIStore.TokenType>();
    let [daysBack, setDaysBack] = useState<number>(30);


    let {
        requestPatientsByPracticeIdWithDays,
        Patients,
        requestConsolidatedPatientById,
        requestCurrentUserCareCoordinatorProfile,
        requestMessageContactsForPractice,
        receiveTokenResponse,
        APIToken
    } = props;
    let userPracticeCoordinatorProfile: APIStore.PracticeCoordinatorState = props.userPracticeCoordinatorProfile;

    let { patientsByPracticeId, isLoading, isLoaded, isError, errorMessage, fullPatients }: APIStore.PatientState = Patients;

    const classes = useStyles();

    const tableColumns = [
        {
            name: "Readmit",
            options: {
                display: true,
                setCellProps: () => ({ style: { minWidth: "50px", maxWidth: "50px" } }),
                filter: false
            },
        },
        {
            name: "id",
            options: {
                display: false,
                filter: false
            }
        },

        {
            name: "Facility",

            options: {
                filterType: 'checkbox'
            },
        },
        {
            name: "First Name",
            options: {
                filter: false
            },
        },
        {
            name: "Last Name",
            options: {
                filter: false
            },
        },
        {
            name: "AdmitDate",
            label: "Admit Date",
            options: {
                sort: true,
                customBodyRender: value => {
                    let dt = moment(new Date(value).getTime());
                    if (dt.isValid()) {
                        return dt.format(SPACED_DATE_FORMAT);;
                    } else {
                        return 'N/A'
                    }
                },
                filter: true
            }
        },
        {
            name: "Days To Discharge",
            options: {
                filter: true,
                customBodyRender: value => {
                    if (value == 10001) {
                        return 'N/A'
                    }

                    if (value == 10002) {
                        return 'DISC'
                    }

                    return value;
                },
            }
        },
        {
            name: "Assigned MD",
            options: {
                filter: true
            },
        },
        {
            name: "primaryCareProvider",
            label: "Primary Care Physician",
            options: {
                filter: true,
                display: true
            },
        },
        {
            name: "payer",
            label: "Payer",
            options: {
                filter: true,
                display: true
            },
        },
        {
            name: "Room",
            label: "Room",
            options: {
                filter: true,
                display: true
            },
        },
        {
            name: "AdmitStamp",
            options: {
                display: false,
                filter: false

            },
        },

    ];


    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
                receiveTokenResponse(token);
            }
        });

    useEffect(() => {
        if (APIToken && !tokenState?.accessToken) {
            setTokenState(APIToken);
        }

    }, [APIToken, tokenState])


    useEffect(() => {
        if (userPracticeCoordinatorProfile) {
            let { isErrored, notFound, isLoaded } = userPracticeCoordinatorProfile
            if ((!isErrored && !notFound && !isLoaded) && tokenState?.accessToken) {
                requestCurrentUserCareCoordinatorProfile(tokenState.accessToken);

            } else {
                if (isLoaded && tokenState?.accessToken) {
                    let coordinatorProfile = userPracticeCoordinatorProfile.coordinatorProfile;
                    requestMessageContactsForPractice(tokenState.accessToken, coordinatorProfile.defaultPractice.practiceId);
                    fetchPatientsForPractice(
                        tokenState?.accessToken,
                        coordinatorProfile.defaultPractice.practiceId,
                        coordinatorProfile.practiceCareCoordinatorId,
                        daysBack,
                        requestPatientsByPracticeIdWithDays
                    );
                }

            }
        }

    }, [tokenState, userPracticeCoordinatorProfile.coordinatorProfile, daysBack]);

    useEffect(() => {
        if (!isLoading && !isLoaded) {
            if (patientsByPracticeId && patientsByPracticeId.length > 0 && tokenState) {
                for (let pt of patientsByPracticeId) {
                    let fps = fullPatients.filter(fm => fm.patientEncounterId === pt.ptId);
                    if (!fps.length) {
                        requestConsolidatedPatientById(pt.ptId, tokenState.accessToken)
                    }
                }
            }
        }

    }, [patientsByPracticeId, userPracticeCoordinatorProfile]);


    useEffect(() => {
        if (userPracticeCoordinatorProfile.notFound) {
            history.push('/patient-list');
        }

    }, [userPracticeCoordinatorProfile])

    const options = {
        onRowClick: (
            rowData: string[],
            rowMeta: { dataIndex: number; rowIndex: number }
        ) => patientRowClick(rowData, rowMeta),
        elevation: 0,
        filter: true,
        viewColumns: false,
        selectableRows: false,
        customSort: (data, colIndex, order) => {
            return data.sort((a, b) => {
                if (colIndex == 5) {
                    if (order === "asc") {
                        return a.data[ADMIT_STAMP_COL_NUM] - b.data[ADMIT_STAMP_COL_NUM]

                    } else {
                        return b.data[ADMIT_STAMP_COL_NUM] - a.data[ADMIT_STAMP_COL_NUM]
                    }
                }
                return (
                    (a.data[colIndex].length < b.data[colIndex].length ? -1 : 1) *
                    (order === "desc" ? 1 : -1)
                );
            });
        },
        print: true,
        delete: false,
        download: true,
        searchAlwaysOpen: true,
        responsive: 'vertical',
        customRowRender: (data, dataIndex, rowIndex) => {
            if (data[0] > 0) {
                return (
                    <TableRow onClick={() => patientRowClick(data)} >
                        <Hidden mdUp>
                            <TableCell size='small'><DoneAllIcon fontSize="small" style={{ color: red[500], padding: '0px' }} /></TableCell>
                            <TableCell>
                                <Grid container direction="row" className="notificationsgrid">
                                    <Grid item xs={12}>
                                        <Typography variant="overline" component="div">
                                            {
                                                data[2]
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body1" component="div" gutterBottom>
                                            {
                                                data[3]
                                            }&nbsp;
                                            {
                                                data[4]
                                            }
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="body2" component="div" gutterBottom>
                                            <strong>Admitted: </strong>{
                                                data[5]
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" component="div" gutterBottom>
                                            <strong>Days To Discharge: </strong>{
                                                data[6]
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" component="div" gutterBottom>
                                            <strong>Assigned MD: </strong>{
                                                data[7]
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" component="div" gutterBottom>
                                            <strong>PCP: </strong>{
                                                data[8]
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" component="div" gutterBottom>
                                            <strong>Payer:</strong>{
                                                data[9]
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" component="div" gutterBottom>
                                            <strong>Room:</strong>{
                                                data[10]
                                            }
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </TableCell>
                        </Hidden>
                        <Hidden smDown>
                            <TableCell size='small'><DoneAllIcon fontSize="small" style={{ color: red[500], padding: '0px' }} /></TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[2]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[3]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[4]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[5]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[6]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[7]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[8]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[9]
                                }
                            </TableCell>
                            <TableCell colSpan={1}>
                                {
                                    data[10]
                                }
                            </TableCell>
                        </Hidden>
                    </TableRow>
                )
            }
            return (
                <TableRow onClick={() => patientRowClick(data)} >
                    <Hidden mdUp>
                        <TableCell size='small'>&#8239;</TableCell>
                        <TableCell>
                            <Grid container direction="row" className="notificationsgrid">
                                <Grid item xs={12}>
                                    <Typography variant="overline" component="div">
                                        {
                                            data[2]
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body1" component="div" gutterBottom>
                                        {
                                            data[3]
                                        }&nbsp;
                                        {
                                            data[4]
                                        }
                                    </Typography>
                                </Grid>

                                <Grid item xs={6}>
                                    <Typography variant="body2" component="div" gutterBottom>
                                        <strong>Admitted: </strong>{
                                            data[5]
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2" component="div" gutterBottom>
                                        <strong>Days To Discharge: </strong>{
                                            data[6]
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" component="div" gutterBottom>
                                        <strong>Assigned MD: </strong>{
                                            data[7]
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" component="div" gutterBottom>
                                        <strong>PCP: </strong>{
                                            data[8]
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" component="div" gutterBottom>
                                        <strong>Payer: </strong>{
                                            data[9]
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" component="div" gutterBottom>
                                        <strong>Room: </strong>{
                                            data[10]
                                        }
                                    </Typography>
                                </Grid>
                            </Grid>
                        </TableCell>
                    </Hidden>
                    <Hidden smDown>
                        <TableCell size='small'>&#8239;</TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[2]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[3]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[4]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[5]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[6]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[7]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[8]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[9]
                            }
                        </TableCell>
                        <TableCell colSpan={1}>
                            {
                                data[10]
                            }
                        </TableCell>
                    </Hidden>
                </TableRow>);
        }
    };

    const loadingOptions = {
        filter: false,
        viewColumns: false,
        print: false,
        elevation: 0,
        sort: false,
        download: false,
        customRowRender: (data, dataIndex, rowIndex) => {
            if (dataIndex === 0) {
                return (

                    <TableRow className="animate-flicker">
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className="skeleton" colSpan={1}>
                            &#8239;
                        </TableCell>
                    </TableRow>
                );
            }

            return (
                <TableRow className="animate-flicker">
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className="skeleton-light" colSpan={1}>
                        &#8239;
                    </TableCell>

                </TableRow>
            );
        },
        searchAlwaysOpen: false,

        customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
            const startIndex = page * rowsPerPage;
            const endIndex = (page + 1) * rowsPerPage;
            return (
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={1}>Loading</TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                    </TableRow>
                </TableFooter>
            );
        },

        textLabels: {
            body: {
                noMatch: "Loading",
            },
        },
    };


    const errorOptions = {
        filter: false,
        viewColumns: false,
        print: false,
        elevation: 0,
        sort: false,
        download: false,

        customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
            const startIndex = page * rowsPerPage;
            const endIndex = (page + 1) * rowsPerPage;
            return (
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={1}>{`Error: ${errorMessage}`}</TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                        <TableCell colSpan={1}></TableCell>
                    </TableRow>
                </TableFooter>
            );
        },
        searchAlwaysOpen: false,
        textLabels: {
            body: {
                noMatch: "Error",
            },
        },
    };

    const history = useHistory();

    const patientRowClick = (
        rowData: string[]
    ) => {
        let ptId = rowData[1];
        history.push(`/Patient/${ptId}`);
    };


    if (isLoading || !isLoaded || !userPracticeCoordinatorProfile.isLoaded) {

        return (
            <Slide in timeout={500} direction="left">
                <div className="maincontent">
                    <Paper elevation={1} style={{ padding: 10 }}>
                        <Grid container xs={12} direction="column" alignItems="flex-end">
                            <Grid item xs={4} container alignContent="flex-end" justifyContent="flex-end" direction="column" >

                                <ButtonGroup variant="text" color="secondary" aria-label="patient days included">
                                    <Button disabled><SelectableText textSelected={daysBack === 30} textVal={'30'} /></Button>
                                    <Button disabled><SelectableText textSelected={daysBack === 60} textVal={'60'} /></Button>
                                    <Button disabled><SelectableText textSelected={daysBack === 90} textVal={'90 Days'} /></Button>
                                </ButtonGroup>


                            </Grid>
                        </Grid>
                        <div className="mui-datatable">
                            <MUIDataTable key={'maintableloading'}
                                title={chartTitle}
                                data={[
                                    ["col1", "col2", "col3", "col4", "col5", "col6","col6","col6","col6","col6"],
                                    ["col1", "col2", "col3", "col4", "col5", "col6","col6","col6","col6","col6"],
                                ]}
                                columns={tableColumns}
                                options={loadingOptions}

                            />
                        </div>
                    </Paper>
                </div>
            </Slide>
        );
    }

    if (isError) {
        return (
            <div>
                <div className="mui-datatable">
                    <MUIDataTable
                        title={"Patients for practice ..."}
                        data={[
                            ["col1", "col2", "col3", "col4", "col5", "col6","col6","col6","col6","col6"],
                            ["col1", "col2", "col3", "col4", "col5", "col6","col6","col6","col6","col6"],
                        ]}
                        columns={tableColumns}
                        options={errorOptions}

                    />
                </div>
            </div>
        );
    }



    let chartTitle = `Patients for ${userPracticeCoordinatorProfile.coordinatorProfile.defaultPractice.practiceName}`;


    return (

        <Slide in timeout={500} direction="left">
            <div className="maincontent">
                <Paper elevation={1} style={{ padding: 10 }}>
                    <Grid container xs={12} direction="column" alignItems="flex-end">
                        <Grid item xs={4} container alignContent="flex-end" justifyContent="flex-end" direction="column" >
                            <ButtonGroup variant="text" color="secondary" aria-label="patient days included">
                                <Button onClick={() => setDaysBack(30)}><SelectableText textSelected={daysBack === 30} textVal={'30'} /></Button>
                                <Button onClick={() => setDaysBack(60)}><SelectableText textSelected={daysBack === 60} textVal={'60'} /></Button>
                                <Button onClick={() => setDaysBack(90)}><SelectableText textSelected={daysBack === 90} textVal={'90 Days'} /></Button>
                            </ButtonGroup>
                        </Grid>         
                    </Grid>

                    <div className="mui-datatable">

                        <MUIDataTable
                            key={'maintable_patients'}
                            theme={getMuiTheme()}
                            title={chartTitle}
                            data={patientsByPracticeId.map((item: APIStore.ListPatient) => {

                                return [
                                    item.recentAdmits,
                                    item.ptId,
                                    item.facilityName,
                                    item.firstName,
                                    item.lastName,
                                    formatDate(item.admitDate, true),
                                    item.daysToDischarge,
                                    formatAssignedMD(item.primaryProviderContact),
                                    formatPCPUserName(item.primaryCareProvider),
                                    item.payer,
                                    item.roomNumber,
                                    item.admitStamp
                                ];
                            })}
                            columns={tableColumns}
                            options={options}
                        />
                    </div>
                </Paper>
            </div>

        </Slide>
    );
};

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(PracticeCoordinatorPatientsTable as any);
